export const SYSTEM_SERVICE_TYPES = ["Pickup","Delivery","Dinein"]